import React from 'react'

const Tool=()=> {
  return (
    <div>
        <div class="tool">
        <div class="tool__center center">
          <div class="tool__container">
            <div class="tool__wrap">
              <h2 class="tool__title title" data-aos="animation-scale-y">Ready to Skyrocket in to the Automated digital Space?</h2>
              <div class="tool__info info" data-aos="animation-scale-y" data-aos-delay="150">Get return of your investment. </div>
              <div class="tool__btn" data-aos="animation-scale-y" data-aos-delay="300"><a class="btn btn_white " href="tel:+254790943918" data-effect="mfp-zoom-in">Call Us Now</a></div>
            </div>
            <div class="tool__cloud"><img class="tool__pic js-parallax" data-scale="1.5" data-orientation="right" src="img/cloud.png" alt=""/></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Tool